import * as yup from 'yup';

export function getTranslatedSchema() {
  return yup.object().shape({
    email: yup.string().optional().email(),
    message: yup.string().optional(),
  });
}
